import { Spinner } from "@mychili/clarity-ui";

export const LoadingView = () => (
  <div className="flex justify-center">
    <Spinner size="l" variant="brand" />
  </div>
);
